import { RouteType } from "types/RouteType";
import PlantOverviewStore from "./PlantOverviewStore";

const PlantOverviewRoute: RouteType = {
  name: "Plant Overview",
  path: "/batch-plant/overview",
  layout: "/app",
  group: "Batch Plant",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Plant Overview",
      component: () => import("./PlantOverview.Header"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PlantOverview.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists or if it's an invalid instance
    const existingStore = rootStore.plantOverviewStore as PlantOverviewStore | undefined;
    if (!existingStore || typeof existingStore.reset !== 'function') {
      rootStore.plantOverviewStore = new PlantOverviewStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.plantOverviewStore as PlantOverviewStore;
    store.reset();
    return true;
  },
};

export default PlantOverviewRoute;
